export default "__VITE_ASSET__BQBjZH96__"